import React from 'react'
import { Button, Empty, Result, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import * as routes from "../../constants/routes";

const { Text } = Typography;

export const NotFound = () => {
  return (
    <section className="not-found">
      <Helmet>
        <title>Not Found | TradInn</title>
      </Helmet>
      <div className="container">
        <div className="not-found__wrapper">
          <Result
            status="404"
            title="404"
            subTitle="The page you're looking for can't be found."
            extra={
              <Button type="primary">
                <Link to={routes.HOME}>Back Home</Link>
              </Button>
            }
          />
        </div>
      </div>
    </section>
  );
};
